export default "__VITE_ASSET__BOUFphuh__";